import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchCalendarData, updateCalendarDay, UpdateCalendarDayInput } from '@/api/calendar';

export function useCalendar(propertyId: string, year: number, month: number) {
  return useQuery({
    queryKey: ['calendar', propertyId, year, month],
    queryFn: () => fetchCalendarData(propertyId, year, month),
    enabled: !!propertyId,
  });
}

export function useUpdateCalendarDay(propertyId: string, year: number, month: number) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (input: UpdateCalendarDayInput) => updateCalendarDay(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar', propertyId, year, month] });
    },
  });
}
